<template>
  <div class="page">
    <div class="container">
      <div class="header">
        <div class="logo-icon">A</div>
        <h3>拼接链接</h3>
        <p class="subtitle">作者：Askook</p>
      </div>

      <!-- 提示 -->
      <div class="tip-card">
        <div class="tip-icon">💡</div>
        <div class="tip-content">
          <p>苹果手机打开就是苹果区；需要安卓区修改浏览器UA即可，反过来区同理</p>
          <p>本软件只做前端替换，无需担心安全问题</p>
        </div>
      </div>

      <!-- 输入区 -->
      <div class="card">
        <div class="item">
          <label>充值链接</label>
          <textarea v-model="rebateUrl" placeholder="请粘贴充值链接" rows="3"></textarea>
        </div>
        <div class="item">
          <label>微信区CK</label>
          <textarea v-model="ckUrl" placeholder="请粘贴微信区CK链接" rows="4"></textarea>
        </div>
        <button class="convert-btn" @click="handleConvert">转换</button>
      </div>

      <!-- 结果区 -->
      <div v-if="resultStr" class="card">
        <div class="result-header">
          <label>转换结果</label>
          <span class="result-badge">已生成</span>
        </div>
        <textarea v-model="resultStr" readonly rows="6" @click="selectAll"></textarea>
        <button class="copy-btn" :class="{ copied: copied }" @click="copyResult">
          {{ copied ? '✓ 已复制' : '复制结果' }}
        </button>
      </div>
    </div>

    <!-- Toast 提示 -->
    <transition name="toast">
      <div v-if="toast.show" class="toast" :class="toast.type">{{ toast.msg }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "LinkConvert",
  data() {
    return {
      rebateUrl: "",
      ckUrl: "",
      resultStr: "",
      copied: false,
      toast: { show: false, msg: "", type: "success" },
      toastTimer: null
    };
  },
  methods: {
    handleConvert() {
      if (!this.rebateUrl || !this.ckUrl) {
        this.showToast("请填写充值链接和微信区CK", "error");
        return;
      }
      let openid = this.getUrlParam(this.ckUrl, "openid");
      let openkey = this.getUrlParam(this.ckUrl, "openkey");
      if (!openid || !openkey) {
        this.showToast("CK链接解析不到 openid / openkey，请检查CK链接", "error");
        return;
      }
      const fixParams =
        "&openid=" + openid +
        "&openkey=" + openkey +
        "&sessionid=hy_gameid" +
        "&sessiontype=wc_actoken" +
        "&wxAppid2=wx951bdcac522929b6";
      this.resultStr = this.rebateUrl + fixParams;
      this.copied = false;
      this.showToast("拼接成功", "success");
    },
    getUrlParam(url, name) {
      const reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)");
      const r = url.match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    selectAll(e) {
      e.target.select();
    },
    async copyResult() {
      if (!this.resultStr) return;
      const text = this.resultStr;
      let success = false;
      // 优先使用新版 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text);
          success = true;
        } catch (e) {
          success = false;
        }
      }
      // 旧浏览器 / 非HTTPS 降级方案
      if (!success) {
        try {
          const input = document.createElement("textarea");
          input.value = text;
          input.setAttribute("readonly", "");
          input.style.position = "fixed";
          input.style.top = "0";
          input.style.left = "0";
          input.style.opacity = "0";
          document.body.appendChild(input);
          input.focus();
          input.select();
          input.setSelectionRange(0, text.length);
          success = document.execCommand("copy");
          document.body.removeChild(input);
        } catch (e) {
          success = false;
        }
      }
      if (success) {
        this.copied = true;
        this.showToast("复制成功", "success");
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } else {
        this.showToast("复制失败，请长按结果手动复制", "error");
      }
    },
    showToast(msg, type) {
      clearTimeout(this.toastTimer);
      this.toast = { show: true, msg, type };
      this.toastTimer = setTimeout(() => {
        this.toast.show = false;
      }, 2000);
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: linear-gradient(150deg, #101c33 0%, #16283f 55%, #1d3a57 100%);
  padding: 24px 16px calc(30px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", "Microsoft YaHei", sans-serif;
  position: relative;
  overflow: hidden;
}
/* 背景光斑装饰 */
.page::before,
.page::after {
  content: "";
  position: fixed;
  width: 480px;
  height: 480px;
  border-radius: 50%;
  pointer-events: none;
}
.page::before {
  top: -20%;
  right: -20%;
  background: radial-gradient(circle, rgba(123, 92, 250, 0.25) 0%, transparent 70%);
}
.page::after {
  bottom: -20%;
  left: -20%;
  background: radial-gradient(circle, rgba(91, 124, 250, 0.2) 0%, transparent 70%);
}
.container {
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.header {
  text-align: center;
  color: #fff;
  margin: 8px 0 24px;
}
.logo-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #5b7cfa, #7c5cfa);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 8px 24px rgba(91, 124, 250, 0.4);
}
h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 1px;
  background: linear-gradient(90deg, #fff, #b8c8ff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 1px;
}
.tip-card {
  display: flex;
  gap: 10px;
  background: linear-gradient(135deg, #fff9e0, #ffefb8);
  padding: 12px 14px;
  border-radius: 14px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 200, 60, 0.35);
}
.tip-icon {
  font-size: 18px;
  flex-shrink: 0;
  line-height: 1.6;
}
.tip-content p {
  margin: 0 0 4px;
  color: #8a6d1a;
  font-size: 13px;
  line-height: 1.6;
}
.tip-content p:last-child {
  margin-bottom: 0;
}
.card {
  background: #fff;
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 12px 40px rgba(6, 12, 30, 0.35);
  margin-bottom: 16px;
}
.item {
  margin-bottom: 16px;
}
label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #33475b;
}
textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #1f2d3d;
  background: #f7f9fc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  min-height: 80px;
  max-width: 100%;
  overflow-x: hidden;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
textarea:focus {
  outline: none;
  border-color: #5b7cfa;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(91, 124, 250, 0.15);
}
.convert-btn,
.copy-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  cursor: pointer;
  min-height: 44px;
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s, filter 0.2s;
}
.convert-btn {
  background: linear-gradient(135deg, #5b7cfa, #7c5cfa);
  box-shadow: 0 6px 20px rgba(91, 124, 250, 0.35);
}
.convert-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(91, 124, 250, 0.45);
}
.convert-btn:active {
  transform: translateY(0) scale(0.98);
}
.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.result-header label {
  margin-bottom: 0;
}
.result-badge {
  font-size: 11px;
  color: #00a85c;
  background: rgba(0, 196, 106, 0.12);
  padding: 3px 8px;
  border-radius: 999px;
  font-weight: 600;
}
.copy-btn {
  margin-top: 12px;
  background: linear-gradient(135deg, #00b894, #00d25a);
  box-shadow: 0 6px 20px rgba(0, 196, 106, 0.3);
}
.copy-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 196, 106, 0.4);
}
.copy-btn:active {
  transform: translateY(0) scale(0.98);
}
.copy-btn.copied {
  background: linear-gradient(135deg, #00a85c, #00b894);
}
.toast {
  position: fixed;
  left: 50%;
  bottom: 60px;
  transform: translateX(-50%);
  padding: 12px 20px;
  border-radius: 999px;
  color: #fff;
  font-size: 14px;
  z-index: 999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  background: rgba(31, 45, 61, 0.92);
  white-space: nowrap;
  max-width: 90vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.toast.success {
  background: rgba(0, 196, 106, 0.95);
}
.toast.error {
  background: rgba(255, 91, 91, 0.95);
}
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}
/* 手机端适配 */
@media (max-width: 768px) {
  .page {
    padding: 16px 14px calc(20px + env(safe-area-inset-bottom));
  }
  h3 {
    font-size: 20px;
  }
  textarea {
    font-size: 15px;
  }
  .convert-btn,
  .copy-btn {
    font-size: 15px;
  }
}
</style>
